export default "//file.bilionpass.com/japandx-portal/0.1.15/static/img/Expose-Variable.bfc6ffd6-16392c.ttf";